export default function getInitState() {
  return {
    formIsOpen: false,
    gridIsOpen: true,
    dataTableOptions: {
      server_mode: true,
      show_reset_button: false,
      global_search: {
        visibility: false,
      },
    },
    actions: [],
    formActions: [
      {
        btn_text: '<i class="fas fa-print"></i> Mentés és nyomtatás',
        event_name: "customClick",
        class: "btn btn-success my-custom-class mx-1",
        event_payload: "saveAndPrintEmployabilityOpinion",
      },
    ],
    rowActionsReadOnly: [
      {
        btn_text: '<i class="far fa-folder-open"></i>',
        title: "Megtekintés",
        event_name: "customClick",
        class: "btn btn-outline-info",
        event_payload: "seeDetails",
      },
      {
        btn_text: '<i class="fas fa-print"></i>',
        title: "Nyomtatás",
        event_name: "customClick",
        class: "btn btn-outline-success",
        event_payload: "printRow",
      },
    ],
    rowActions: [
      {
        btn_text: 'Validálás',
        title: 'Validálás',
        event_name: "customClick",
        class: "btn btn-outline-teal",
        event_payload: 'showValidatePopup',
        additionalButtonVisible: "isDocumentValidated",
    },
    {
        btn_text: '<i class="fas fa-print"></i>',
        title: 'Nyomtatás',
        event_name: "customClick",
        class: "btn btn-outline-success",
        event_payload: 'printRow'
    },
    {
        btn_text: '<i class="fas fa-history"></i>',
        title: 'Előzmények',
        event_name: "customClick",
        class: "btn btn-outline-purple",
        event_payload: 'showHistory'
    },
    {
        btn_text: '<i class="far fa-edit"></i>',
        title: 'Szerkesztés',
        event_name: "customClick",
        class: "btn btn-outline-primary",
        event_payload: 'edit',
        additionalButtonVisible: "isDocumentValidated",
    },
    {
        btn_text: '<i class="fas fa-unlock"></i>',
        title: 'Felnyitás',
        event_name: "customClick",
        class: "btn btn-outline-info",
        event_payload: 'seeEdit',
        additionalButtonVisible: "isDocumentValidatedReopen",
    },
    {
        btn_text: '<i class="fas fa-trash"></i>',
        title: 'Törlés',
        event_name: "customClick",
        class: "btn btn-outline-danger",
        event_payload: 'deleteRow',
        additionalButtonVisible: "isDocumentValidated",
    },
    {
        btn_text: '<i class="fas fa-undo"></i>',
        title: 'Visszaállítás',
        event_name: "customClick",
        class: "btn btn-outline-warning",
        seeCaseOfDeleted: true,
        event_payload: 'unDeleteRow',
    }
    ],
    headerFields: [
      {
        name: "id",
        label: "ID",
        visibility: false,
      },
      {
        name: "treatmentId",
        label: "treatmentId",
        visibility: false,
      },
      {
        name: "treatment",
        label: "treatment",
        visibility: false,
      },
      {
        name: "employeeName",
        label: "Munkavállaló neve",
        visibility: false,
        viewModalShow: true,
        formSize: 3,
        formType: "text",
      },
      {
        name: "employeeGender",
        label: "Munkavállaló neme",
        visibility: false,
        viewModalShow: true,
        formSize: 3,
        formType: "text",
      },
      {
        name: "employeeBirthDate",
        label: "Munkavállaló születési dátuma",
        visibility: false,
        viewModalShow: true,
        formSize: 3,
        formType: "date",
      },
      {
        name: "employeeBirthPlace",
        label: "Munkavállaló születési helye",
        visibility: false,
        viewModalShow: true,
        formSize: 3,
        formType: "text",
      },
      {
        name: "employeeMotherName",
        label: "Munkavállaló anyja neve",
        visibility: false,
        viewModalShow: true,
        formSize: 3,
        formType: "text",
      },
      {
        name: "employerName",
        label: "Employer Name",
        visibility: false,
        viewModalShow: true,
        formSize: 3,
        formType: "text",
      },
      {
        name: "sicknessDueToWork",
        label: "Munkakör",
        visibility: true,
        viewModalShow: true,
        formSize: 3,
        formType: "text",
      },

      {
        name: "diagnose.text",
        label: "Diagnózis",
        visibility: true,
        viewModalShow: true,
        formSize: 3,
        formType: "text",
      },

      {
        name: "feorCode",
        label: "FEOR Code",
        visibility: false,
        viewModalShow: true,
        formSize: 3,
        formType: "text",
      },
      {
        name: "employerTaxNumber",
        label: "Employer Tax Number",
        visibility: false,
        viewModalShow: true,
        formSize: 3,
        formType: "text",
      },

      {
        name: "workGroup",
        label: "Work Group",
        visibility: false,
        viewModalShow: true,
        formSize: 4,
        formType: "text",
      },
      {
        name: "previousWorkGroups",
        label: "Previous Work Groups",
        visibility: false,
        viewModalShow: true,
        formSize: 3,
        formType: "text",
      },

      {
        name: "occouranceType.text",
        label: "Occurrence Type",
        visibility: false,
        viewModalShow: true,
        formSize: 4,
        formType: "text",
      },
      {
        name: "salaryOption.text",
        label: "Salary Option",
        visibility: false,
        viewModalShow: true,
        formSize: 4,
        formType: "text",
      },
      {
        name: "sicknessInCurrentWork",
        label: "Jelenlegi munkakörbeni beteg hónap",
        visibility: false,
        viewModalShow: true,
        formSize: 2,
        formType: "number",
      },
      {
        name: "sicknessInAllWork",
        label: "Összes munkakörbeni beteg hónap",
        visibility: false,
        viewModalShow: true,
        formSize: 2,
        formType: "number",
      },
      {
        name: "county.name",
        label: "County",
        visibility: false,
        viewModalShow: true,
        formSize: 2,
        formType: "text",
      },
      {
        name: "doctorName",
        label: "Doktor neve",
        visibility: false,
        viewModalShow: true,
        formSize: 3,
        formType: "text",
      },
      {
        name: "doctorType.text",
        label: "Bejelentő doktor típusa",
        visibility: false,
        viewModalShow: true,
        formSize: 3,
        formType: "text",
      },
      {
        name: "createdBy",
        label: "Létrehozó",
        visibility: true,
        viewModalShow: false,
        formSize: 3,
        formType: "text",
      },
      {
        name: "createdOn",
        label: "Létrehozva",
        visibility: true,
        viewModalShow: false,
        formSize: 3,
        formType: "date",
        slot_name: "resultdate_format",
      },
      {
        name: "modifiedBy",
        label: "modifiedBy",
        visibility: false,
      },
      {
        name: "modifiedOn",
        label: "modifiedOn",
        visibility: false,
      },
      {
        name: "deleted",
        label: "deleted",
        visibility: false,
      },
      {
        name: "validated",
        label: "Státusz",
        visibility: true,
        slot_name: "validated_format",
    },
      {
        name: "buttons",
        label: "Opciók",
        sort: false,
        viewModalShow: false,
      },
    ],
  };
}
